<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import { axiosGetPost } from '@router/axiosGetPost'
import DuplicateLog from '@/src/components/request/DuplicateLog'
import WaitingStatus from '@/src/components/WaitingStatus'
import moment from 'moment'

export default {
  page: {
    title: 'Account Details',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, DuplicateLog, WaitingStatus },
  props: {
    user: {
      type: [Array, Object],
      default: function() {
        return {}
      },
    },
  },
  data() {
    return {
      title: 'Accounts Details',
      items: [
        {
          text: 'Barracuda',
          href: '/',
        },
        {
          text: 'Accounts',
          href: '/accounts/fcl',
        },
        {
          text: 'Detaills',
          active: true,
        },
      ],
      request_id: this.$route.params.id,
      errors: [],
      validation: null,
      name: null,
      companyUser: null,
      statusContract: null,
      statusRequest: null,
      isDuplicated: null,
      date: null,
      loandingData: false,
      module: 'FCL',

      duplicateLogs_id: null,
      loadingData: true,
      showModal: false,
      modalComponent: 'changeStatus',
      modalTitle: 'Status',
      modalError: null,
      modalErrorShow: false,
    }
  },
  watch: {
    // call again the method if the route changes
    $route: 'getData',
  },
  created() {
    // fetch the data when the view is created and the data is
    // already being observed
    this.getData()
  },
  methods: {
    getData() {
      // replace `getPost` with your data fetching util / API wrapper
      // console.log(this.request_id)
      axiosGetPost(
        'post',
        'requests/account_actions/' + this.request_id,
        {},
        'Show Detail account FCL'
      ).then((response) => {
        let data = response.data
        // console.log(data)
        this.name = data.name
        this.companyUser = data.company_user
        this.date = data.date
        this.statusContract = data.status_contract
        this.statusRequest = data.status_request
        this.isDuplicated = data.is_duplicated
        return data
      })
    },
    test() {
      console.log()
    },
    redirectGoodAndFail() {
      axiosGetPost('post', '/contracts/getStatusTask/' + this.request_id).then(
        (response) => {
          let data = {
            name: 'goodandfails',
            params: { id: this.request_id, module: 'FCL' },
          }
          if (response.data !== true) {
            data = {
              name: 'reviews_module',
              params: { id: this.request_id, module: 'FCL' },
            }
          }
          this.$router.push(data)
          return response
        }
      )
    },
    searchDuplicatedLog(id) {
      axiosGetPost(
        'get',
        '/requests/accountSearch/' + id,
        {},
        'Search Log Duplicated FCL Account'
      ).then((response) => {
        // console.log(response)
        let data = response.data
        this.modalTitle = 'Possible Duplicates '
        this.modalComponent = 'DuplicateLog'
        this.showModal = true
        this.duplicateLogs_id = data
        this.loadingData = true
        this.loadingData = false
        return data
      })
    },
    reImportContract() {
      axiosGetPost(
        'PUT',
        '/contracts/import_contract/' + this.request_id,
        {},
        'Re-Importation FCL'
      ).then((response) => {
        // console.log(response)
        let data = response.data
        this.modalTitle = 'Waiting...'
        this.modalComponent = 'WaitingStatus'
        this.showModal = true
        this.loadingData = false
        return data
      })
    },
    downloadFile(id) {
      axiosGetPost(
        'get',
        '/contracts/downloadF/' + id,
        {},
        'Download File Fcl. Operations'
      ).then((response) => {
        // console.log(response)
        let data = response.data
        if (data.success === true) {
          var link = document.createElement('a')
          link.setAttribute('target', '_blank')
          link.href = data.url
          link.click()
          URL.revokeObjectURL(link.href)
        } else {
          this.$toastr.e(
            'Error Download. Status code: ' +
              data.status +
              ' Error: ' +
              data.error
          )
        }
        return data
      })
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <form action>
            <div class="card-body">
              <h4 class="header-title mb-3 mt-0">
                Account Detail / Request: {{ request_id }} -
                <span
                  v-if="isDuplicated === true"
                  class="badge"
                  :class="{
                    'badge-soft-info': isDuplicated === true,
                  }"
                  >Duplicated</span
                >
                <span
                  v-if="isDuplicated === false"
                  class="badge"
                  :class="{
                    'badge-soft-success': isDuplicated === false,
                  }"
                  >Importation</span
                >
              </h4>
              <div v-if="loandingData === false">
                <div class="form-group">
                  <div class="row">
                    <div class="col-md col-md-4">
                      <label for="name"> Reference </label>
                      <b-form-input
                        id="name"
                        v-model="name"
                        value
                        placeholder="Write name"
                        readonly
                      ></b-form-input>
                    </div>
                    <div class="col-md col-md-2">
                      <label for="name"> Date </label>
                      <b-form-input
                        id="name"
                        v-model="date"
                        value
                        placeholder="Write name"
                        readonly
                      ></b-form-input>
                    </div>
                    <div class="col-md col-md-2">
                      <label for="name"> Company User </label>
                      <b-form-input
                        id="name"
                        v-model="companyUser"
                        value
                        placeholder="Write name"
                        readonly
                      >
                      </b-form-input>
                    </div>
                    <div class="col-md col-md-2">
                      <label for="name" style="text-decoration: underline red;">
                        <i></i> Status Contract
                      </label>
                      <b-form-input
                        id="name"
                        v-model="statusContract"
                        value
                        placeholder="Write name"
                        readonly
                      >
                      </b-form-input>
                    </div>
                    <div class="col-md col-md-2">
                      <label
                        for="name"
                        style="text-decoration: underline steelblue;"
                      >
                        Status Request
                      </label>
                      <b-form-input
                        id="name"
                        v-model="statusRequest"
                        value
                        placeholder="Write name"
                        readonly
                      >
                      </b-form-input>
                    </div>
                  </div>
                </div>
                <hr />
                <br />
                <div class="form-group">
                  <div class="button-list">
                    <b-button
                      :to="{
                        name: 'account_import',
                        params: {
                          id: request_id,
                          module: 'fcl',
                        },
                      }"
                      class="col-2"
                      variant="primary"
                      >Import With File
                    </b-button>
                    <b-button
                      v-if="!isDuplicated"
                      class="col-2"
                      variant="success"
                      @click="reImportContract"
                      >Reimport</b-button
                    >
                    <b-button
                      v-if="!isDuplicated"
                      class="col-2"
                      @click="downloadFile(request_id)"
                      variant="info"
                    >
                      Download File Op</b-button
                    >
                    <b-button
                      v-else
                      class="col-2"
                      @click="searchDuplicatedLog(request_id)"
                      variant="dark"
                      >Duplicated Log</b-button
                    >
                    <b-button
                      :to="{
                        name: 'goodandfails',
                        params: {
                          id: request_id,
                          module: 'fcl',
                        },
                      }"
                      class="col-2"
                      variant="warning"
                      >Good and Fail</b-button
                    >
                  </div>
                  <div class="row">
                    <!--<div class="col-md col-md-2">
                    </div>-->
                    <div class="col-md col-md-5">
                      <div class="form-group row">
                        <div class="col-sm-7"> </div>
                        <div class="col-md-4"> </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xl-5 col-sm-5"></div>
                    <div class="col-xl-2 col-sm-2">
                      <div class="form-group mt-1 mt-sm-0"> </div>
                    </div>
                  </div>
                </div>

                <div
                  v-if="loandingData"
                  class="row align-items-center justify-content-center"
                  style="height: 300px"
                >
                  <div class="col-12 col-md-8 text-center">
                    <b-spinner
                      label="Loading..."
                      variant="secondary"
                      class="ml-3"
                    ></b-spinner>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <!-- <b-button variant="success" @click="test">methods</b-button> -->
      <b-modal
        id="modal-lg"
        ref="requestFcl"
        v-model="showModal"
        size="lg"
        :title="modalTitle"
        title-class="font-18"
      >
        <div
          v-if="loadingData"
          class="row align-items-center justify-content-center"
          style="height: 300px"
        >
          <div class="col-12 col-md-8 text-center">
            <b-spinner
              label="Loading..."
              variant="primary"
              class="ml-3"
            ></b-spinner>
          </div>
        </div>

        <div v-else-if="modalErrorShow === true">
          <div
            class="row align-items-center justify-content-center"
            style="height: 300px"
          >
            <div class="col-12 col-md-8 text-center">
              <feather type="frown" class="icon-xxl icon-dual-info"></feather>
              <h6 class="text-muted">{{ modalError }}</h6>
            </div>
          </div>
        </div>

        <DuplicateLog
          v-else-if="modalComponent === 'DuplicateLog'"
          :request-id="duplicateLogs_id"
          type="FCL"
        />
        <WaitingStatus
          v-else-if="modalComponent === 'WaitingStatus'"
          :request-id="request_id"
          :reload-time="10"
          @postevent="redirectGoodAndFail"
          has-post-event
          url="/contracts/getStatusTask/"
        />
        <template v-slot:modal-footer>
          <b-button variant="light" @click="$refs.requestFcl.hide"
            >Close</b-button
          >
          <!--<b-button v-if="
            loadingData === false &&
            modalErrorShow === false &&
            modalComponent !== 'DuplicateLog'
          " variant="primary" >
            OK
          </b-button>-->
        </template>
      </b-modal>
    </div>
  </Layout>
</template>
<style>
.DRY {
  color: blue;
}
</style>
